/* 
 * NOTICE OF LICENSE
 * 
 * This source file is subject to the Academic Free License (AFL 3.0)
 * 
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2019 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */


import $ from 'jquery';

( function() {
    
    if($('.error-404').length){
        var pageX = $(document).width();
        var pageY = $(document).height();
        var mouseY=0;
        var mouseX=0;

        $(document).mousemove(function( event ) {
            mouseY = event.pageY;
            var yAxis = (pageY/2-mouseY)/pageY*300; 
            mouseX = event.pageX / -pageX;
            var xAxis = -mouseX * 100 - 100;

            $('.box__ghost-eyes').css({ 'transform': 'translate('+ xAxis +'%,-'+ yAxis +'%)' }); 
        });
    }
    
} )();